import { useState, useEffect, forwardRef } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "heilys_cookie_consent";

const CookieBanner = forwardRef<HTMLDivElement>((_, ref) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div ref={ref} className="fixed inset-x-0 bottom-0 z-50 p-3 md:p-4">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-3 rounded-xl border border-border/50 bg-card/95 px-4 py-3 shadow-xl backdrop-blur-lg sm:flex-row sm:justify-between">
        <p className="text-xs leading-relaxed text-muted-foreground sm:text-sm">
          Diese Website verwendet nur technisch notwendige Cookies.{" "}
          <Link to="/datenschutz" className="font-medium text-foreground underline underline-offset-2 hover:text-primary">
            Mehr erfahren
          </Link>
        </p>
        <button
          onClick={handleDismiss}
          className="shrink-0 rounded-md bg-primary px-4 py-1.5 text-xs font-medium text-primary-foreground transition-colors hover:brightness-110"
        >
          Verstanden
        </button>
      </div>
    </div>
  );
});

CookieBanner.displayName = "CookieBanner";

export default CookieBanner;
